<script>
// import appConfig from '@src/app.config'
import { GroupApi } from '@chirhos/chirhos-api'
import { ChiRhos } from '@paladin/core'

const ChiRhosApi = new ChiRhos().api()
var groupApi = new GroupApi(ChiRhosApi)

export default {
  page: {
    title: 'Invite',
    // meta: [{ name: 'description', content: appConfig.description }],
  },
  props: {
    code: {
      type: String,
      default: '',
      required: false,
    },
  },
  data() {
    return {
      acceptInviteForm: {
        code: '',
      },
    }
  },
  mounted: function() {
    // console.log(this.code)
    if (this.code) this.acceptInviteForm.code = this.code
  },
  methods: {
    acceptInviteSubmit(evt) {
      evt.preventDefault()

      groupApi
        .AcceptInvite({
          secret: this.acceptInviteForm.code,
        })
        .then(
          (/* response */) => {
            // console.log(response)
            this.acceptInviteForm.code = ''
            this.$toast('Invite accepted', 'success')
          },
          (error) => {
            console.error(error)
            this.$toast(error, 'error')
          }
        )
    },
  },
}
</script>

<template>
  <b-card title="Welcome to Planted" sub-title="">
    <b-form inline @submit="acceptInviteSubmit">
      <label class="sr-only">
        Invite Code
      </label>
      <b-input
        v-model="acceptInviteForm.code"
        class="mb-2 mr-sm-2 mb-sm-0"
        placeholder="Invite code"
        required
      />
      <b-button type="submit" variant="primary">
        Accept Invite
      </b-button>
    </b-form>
  </b-card>
</template>
